import React from "react";

export const CourseCardSkeleton = () => {
  return (
    <div className="sm:p-3 sm:h-[206px] rounded md:items-center sm:flex-row flex-col  flex border border-[#ccccccb3] relative shadow-[0_0.125rem_0.25rem_rgb(0,0,0,0.08)] hover:shadow-[0_0.125rem_0.25rem_#ffe7a0] hover:border-[#ffc107] justify-items-center">
      <div className="flex sm:mb-0 mb-2 sm:p-0 p-3">
        <div className="relative overflow-hidden shrink-0 w-[89px] h-[68px] sm:w-[160px] sm:h-[148px] lg:w-[258px] lg:h-[156px] rounded-[12px] bg-gray-50 animate-pulse" />
        <div className="animate-pulse flex flex-col mr-3 w-[calc(100%-120px)] justify-between">
          <div className="relative flex-col flex ">
            <div className="bg-gray-50 animate-pulse w-1/3 h-5 " />
            <div className="bg-gray-50 animate-pulse w-2/3 mt-4 h-5 " />

            <div className="flex md:items-center items-start gap-0 mmd:flex-col sm:flex-row md:gap-4 md:mb-1 mt-2">
              <div className="mmd:hidden sm:flex flex items-center h-5 rounded-sm justify-center xl:justify-start w-1/4 lg:justify-start bg-gray-50"></div>
              <div className="mmd:hidden mt-1 md:mt-0 flex items-center h-5 rounded-sm justify-center xl:justify-start w-1/4 lg:justify-start bg-gray-50"></div>
            </div>
          </div>

          <div className="animate-pulse sm:block hidden mr-auto h-full ">
            <div className="rounded-[3px] mmd:hidden w-[186px] h-10 bg-gray-50" />
            <div className="rounded-sm hidden h-4 w-[122px] mr-auto sm:relative mmd:flex mt-1 bg-gray-50 text-xs font-medium" />
          </div>
        </div>
        <div className="sm:hidden items-center flex-col  flex  ">
          <div className="rounded-full bg-[#A5CFF5] flex items-center justify-center border-2 outline-offset-2 border-white outline-[#A5CFF5] outline outline-2  w-6 h-6" />
        </div>
      </div>

      <div className=" sm:hidden pl-2 pr-4 h-16 rounded-b-lg bg-[#FAFAFA] border-t border-t-[#F4F4F5] justify-center flex items-center">
        <div className="w-20 h-5 bg0gray-50 animate-pulse" />
      </div>
    </div>
  );
};
